import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountingList from './components/AccountingList'


const { Cell } = ResponsiveGrid;

const Accounting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="會計列表"
        breadcrumbs={[
          {
            name: '會計系統',
          },
          {
            name: '會計列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountingList />
    </Cell>
  </ResponsiveGrid>
);

export default Accounting;
